import React from 'react';
import { PageHeader, Section } from '../components/PageShell';

export function Privacy() {
  return (
    <div data-testid="privacy-page" className="pb-24">
      <PageHeader
        eyebrow="Legal"
        title={<><span className="font-serif">Privacy</span> Policy</>}
        subtitle="How YP Nova collects, uses and safeguards your information."
      />
      <Section>
        <div className="prose max-w-3xl text-[#0D212C]">
          <p className="text-[#273C46] leading-relaxed">
            YP Nova (&ldquo;we&rdquo;, &ldquo;us&rdquo;) respects your privacy. This placeholder page
            outlines the categories of data we collect (contact form
            submissions, basic analytics), how we use it (to respond to your
            enquiry and improve our services), how long we retain it, and how
            you can request access, correction or deletion.
          </p>
          <p className="text-[#273C46] leading-relaxed mt-4">
            A full policy compliant with GDPR, CCPA and relevant regional
            regulations will be published prior to production launch. For any
            data request, contact <a href="mailto:privacy@ypnova.example.com" className="underline underline-offset-4">privacy@ypnova.example.com</a>.
          </p>
        </div>
      </Section>
    </div>
  );
}

export function Terms() {
  return (
    <div data-testid="terms-page" className="pb-24">
      <PageHeader
        eyebrow="Legal"
        title={<><span className="font-serif">Terms</span> of Service</>}
        subtitle="The terms that govern the use of this website and any engagement with YP Nova."
      />
      <Section>
        <div className="prose max-w-3xl text-[#0D212C]">
          <p className="text-[#273C46] leading-relaxed">
            This placeholder page will contain the terms governing website use,
            intellectual property, engagement terms, warranties, limitation of
            liability and dispute resolution.
          </p>
          <p className="text-[#273C46] leading-relaxed mt-4">
            All commercial engagements with YP Nova are governed by a separate
            Master Services Agreement (MSA) executed prior to project kick-off.
            For questions, contact <a href="mailto:legal@ypnova.example.com" className="underline underline-offset-4">legal@ypnova.example.com</a>.
          </p>
        </div>
      </Section>
    </div>
  );
}
